import React, { type ComponentProps } from 'react'

import { scaryTheme } from '../themes'
import { ThemeProvider } from './ThemeProvider'

type Props = {
  children: ComponentProps<typeof ThemeProvider>['children']
}

/**
 * This component causes all its descendants to use the 'scary' theme.
 *
 * You should use this for sections of the app where users need to exercise extra caution,
 * particularly if they're about to take permanent actions such as deleting their account.
 */
export function ScaryOverride({ children }: Props) {
  return <ThemeProvider theme={scaryTheme}>{children}</ThemeProvider>
}
